<template>
  <skeleton-box :delay="index">
    <v-container grid-list-lg fluid>
      <v-layout row wrap>
        <v-flex xs3>
          <skeleton-avatar size="50px">
          </skeleton-avatar>
        </v-flex>
        <v-flex xs9>
          <skeleton-line size="lg">
          </skeleton-line>
          <skeleton-line size="sm" class="mt-2 mb-0">
          </skeleton-line>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <skeleton-line size="lg">
          </skeleton-line>
        </v-flex>
      </v-layout>
      <v-container grid-list-xs fluid>
        <v-layout row wrap class="chat-info">
          <v-flex xs3>
            <skeleton-line size="sm">
            </skeleton-line>
          </v-flex>
          <v-flex xs3>
            <skeleton-line size="sm">
            </skeleton-line>
          </v-flex>
          <v-flex xs3>
            <skeleton-line size="sm">
            </skeleton-line>
          </v-flex>
          <v-flex xs3>
            <skeleton-line size="sm">
            </skeleton-line>
          </v-flex>
        </v-layout>
      </v-container>
    </v-container>
  </skeleton-box>
</template>

<script>
import SkeletonAvatar from '@/components/global/skeletons/Avatar';
import SkeletonLine from '@/components/global/skeletons/Line';
import SkeletonBox from '@/components/global/skeletons/SkeletonBox';

export default {
  components: {
    SkeletonAvatar,
    SkeletonLine,
    SkeletonBox,
  },
  props: {
    index: {
      type: Number,
      default: 0,
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/chat_center_v2/CardSkeleton.vue